import {
  BlockContentValue,
  BackgroundColor,
  PartialSanityImageType,
  SanityImage,
  SanityImageRatio,
  SectionTitle,
  SectionTitleHeading,
  SectionTitleProps
} from "@silversea-ssc/ui-components-react";
import clsx from "clsx";
import { BlockContent } from "components/BlockContent";
import React, { ReactElement } from "react";
import * as styles from "./BrochurePageBox.module.scss";

type Props = {
  image?: PartialSanityImageType;
  sectionTitle?: string;
  title?: string;
  content?: string | BlockContentValue;

  ctaButton: ReactElement;
  backgroundColor: BackgroundColor | "titanium";
  titleColor: SectionTitleProps["textColor"];
};

const BrochurePageBox: React.FC<React.PropsWithChildren<Props>> = ({
  image,
  sectionTitle,
  title,
  content,
  ctaButton,
  backgroundColor,
  titleColor
}) => {
  return (
    <React.Fragment>
      <SectionTitle variant="wide" textColor={titleColor}>
        <SectionTitleHeading className={styles.title}>
          {sectionTitle}
        </SectionTitleHeading>
      </SectionTitle>
      <div
        className={clsx(styles.section, {
          [styles.backgroundWhite]: backgroundColor == "white",
          [styles.backgroundNeutral05]: backgroundColor == "neutral05",
          [styles.backgroundNeutral10]: backgroundColor == "neutral10",
          [styles.backgroundTitanium]: backgroundColor == "titanium"
        })}
      >
        <div className={styles.imgContainer}>
          <div className={styles.imgContainerWrapper}>
            {image && (
              <SanityImageRatio image={image} ratio="auto">
                <SanityImage image={image} />
              </SanityImageRatio>
            )}
          </div>
        </div>
        <div className={styles.content}>
          <h3 className={styles.subtitle}>{title}</h3>
          <div className={styles.paragraph}>
            <BlockContent value={content} />
          </div>
          <div className={styles.footer}>{ctaButton}</div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BrochurePageBox;
